import styled from "src/settings/theme/styled";
import theme from "src/settings/theme";

export const Nav = styled.nav`
  margin: 2vw 0 0 0;
  ${theme.breakpoints.mobile} {
    display: flex;
    flex-direction: row;
    max-width: 285px;
    width: 100%;
    flex-wrap: wrap;
  }
  ${theme.breakpoints.mobileSm} {
    margin: 0 10vw 2vw 0;
    max-width: 100%;
  }
`;

export const Link = styled.a`
  text-decoration: none;
  display: inline-block;
  margin: 0 2.4vw 0 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray};
  transition: ${({ theme }) => theme.animations.defaultTransition};
  &:hover {
    color: ${({ theme }) => theme.colors.white};
    font-weight: 700;
  }

  ${theme.breakpoints.mobile} {
    margin-bottom: 1.45vh;
  }

  ${theme.breakpoints.mobileSm} {
    margin: 0 10vw 2vw 0;
  }
`;
